// @ts-expect-error
import * as _ from "lodash-es";
import { Document, Page, pdfjs } from "react-pdf";
import React, { useContext, useEffect, useState } from "react";
import IQBOGetPdfEstimateDTO from "../../../models/DTO/IQBOGetPdfEstimateDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UserTypesEnum from "../../../models/UserTypesEnum";
import OwButton from "../../shared/OwButton/OwButton";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type Props = {
    cancel: (refresh?: boolean) => void;
    vendorGuid: string;
    vendorEmail: string;
    qboEstimateId: string;
};

export const QBOEstimatePdfSidebarViewer: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;

    const [file, setFile] = useState<any>();

    const onGetPdfEstimate = (data: any) => {
        setFile(data);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.QBOOnGetPDFEstimate, fn: onGetPdfEstimate }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getPdfEstimate();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const getPdfEstimate = () => {
        const payload: IQBOGetPdfEstimateDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.vendorGuid,
            entityId: props.qboEstimateId,
        };

        socket.emit(EndpointsEnum.QBOGetPDFEstimate, payload);
    };

    const downloadPdfEstimate = () => {
        if (file) {
            const blob = new Blob([file], { type: "application/pdf" }); // change resultByte to bytes

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            const fileName = props.qboEstimateId;

            link.download = `Estimate ${fileName}.pdf`;
            link.click();
        }
    };

    return (
        <div className={"QBOEstimatePdfSidebarViewer p-2"}>
            <div className="header">
                <div className="text-end">
                    <OwButton
                        centerIconClass={"far fa-times"}
                        className={"btn-danger"}
                        fn={() => {
                            props.cancel();
                        }}
                    />
                </div>
                <div className="mt-2 mb-2">
                    <OwButton
                        className={"btn-sm btn-primary me-2"}
                        fn={downloadPdfEstimate}
                        leftIconClass={"fas fa-download"}
                        title={"download"}
                    />
                </div>
            </div>
            <div style={{ height: "90vh", overflow: "scroll" }}>
                <Document className="vh-90" renderMode="canvas" file={file}>
                    <Page pageIndex={0} />
                </Document>
            </div>
        </div>
    );
};
